import { render, staticRenderFns } from "./GuideReadField.vue?vue&type=template&id=63b5fb88"
import script from "./GuideReadField.vue?vue&type=script&lang=js"
export * from "./GuideReadField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports